import Popup from 'reactjs-popup';
import styled from 'styled-components';

const StyledPopup = styled(Popup)`
  &-overlay {
    background: rgba(0, 0, 0, 0.15); /* Dark overlay background */
  }

  &-content {
    position: fixed !important;
    top: 0;
    right: 0;
    height: 100vh;
    width: 386px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease-in-out;
    transform: translateX(100%); /* Initially hide the modal off-screen to the right */
		border:none;
		padding: .85rem 0rem 1rem 1rem;
    &.open-content {
      transform: translateX(0); /* Slide in when open */
			background:var(--sidebarBgColor);
    }

    &.close-content {
      transform: translateX(100%); /* Slide out when closed */
    }
  }
`;

export { StyledPopup };

export const ModalContent = styled.div`
`; 

export const EditFacetModalBtnWrap = styled.div`
	
	button.edit-facet-btn{
		margin-top: 3px;
		margin-bottom: .5rem;
		background: var(--btnBgdefault);
		width: 100%;
		color:var(--textTitleColor);
		font-weight: 500;
		// border: 1px solid #D6D6D6;
		font-size: 15px;
		line-height: 18px;
		cursor: pointer !important;
		padding: 10px 2rem;
		// border-radius: 2rem;
		gap:8px;
		cursor: pointer !important;
    // border: 1px solid #dcdcdc;
		border: 1px solid var(--borderColor);
    border-radius: 8px;
    font-weight: 500;
	&:disabled{
		cursor: not-allowed !important;
		opacity: .6 !important;
	}
}
	}
	`;

export const Heading = styled.h4`
		font-family: 'Inter';
    font-weight: 500;
    font-size: 16px;
	  line-height: 18px;
    color: var(--textColor);
    margin: 0 0px 4px;
	`;

export const DivFacetDetail = styled.div`
	padding: 0.938rem 1rem;
	background: var(--modalBgColor);
	box-shadow: none;
	border: 1px solid var(--borderLightColor);
	transition: 0.25s;
	border-radius: 12px;
	margin-bottom: .815rem;
		&.active {
			background: var(--activeBgColor);
    	border: 1px solid rgb(125, 162, 255);
    	box-shadow: rgba(125, 162, 255, 0.25) 0px 4px 8px;
		}
		&.edited {
		background: var(--defaultBgColor);
		border: 1px dashed rgb(125, 162, 255);

		&.active{
				background: var(--activeBgColor);
		}
	}
`;

export const ModalFacetWrap = styled.div`
width: 100%;
		.pitch-toggle{
			.switch {
				width: 36px;
				height: 14px;
			}
			.slider::before {
					height: 21px;
					width: 21px;
					top: -5px;
			}
		}

`;
export const FacetWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: .75rem;
	padding-right: 1rem;
	min-height:36px;
`;

export const ModalFacetBox = styled.div`
		padding: 1rem .85rem .65rem;
    background: var(--defaultBgColor);
    box-shadow: none;
    border: none;
    border-radius: 0px;
    margin-bottom: .815rem;
	
		&.active {
		background: var(--facetActiveBgColor);

			button{
				background: var(--defaultBgColor);
			}
		}
`;

export const ModalFacetInfoWrap = styled.div`
		overflow-y: auto;
		height: calc(100vh - 100px);
    padding-right: .5rem;
		pading-bottom:20px;
			@supports (height: 100dvh) {
					height: calc(100dvh - 100px);
			}
`;
export const FacetTitle = styled.div`
		color: var(--textColor);
		font-size: 1.25rem;
		font-family: 'Inter';
		font-weight: 500;
`;

export const HeadingAzimuth = styled.div`
		font-family: 'Inter';
    font-weight: 500;
    color: var(--textColor);
    margin: 0 0px .35rem;
    line-height: 1.2;
    font-size: 1.063rem;
		span{
			padding-left: 2px;
			font-weight: 400;
			font-size: 1rem;
		}
		sup{
			font-size:.65rem
			font-weight: 400;
		}
`;

export const FacetTitleButtons = styled.div`
		display: flex;
		gap: .5rem;

		.btn-reset{
				background: var(--controlBgColor);
				color: var(--textTitleColor);
				border: 1px solid rgba(0,0,0,.20);
		}
`;

export const WarningContainer = styled.div`
  background-color: var(--defaultBgLightColor);    
  border: 1px solid var(--warningColor);
  border-radius: 4px;
  padding: 0.75rem 1rem;
  margin-top: 0.5rem;
`;

export const WarningText = styled.p`
  color: var(--warningColor);
  margin: 0;
  font-size: 0.875rem;
  line-height: 1.4;
`;

export const AccordianTitle = styled.div`
 	display: flex;
  flex-direction: row;
  cursor: pointer;
	width: 100%;
`;

export const EdgeLengthDiv =styled.div`
	display: flex;
  flex-direction: row;
	width: 100%;
	font-size: 0.875rem;
	gap: 2rem;

	span{
			font-size: 0.875rem;
			line-height: 17px;
			font-weight: 600;
			padding-left: 2px;
			position: relative;
			top: 0px;
			color: var(--labelValueColor);
		}
`;

export const FacetLabelToggle = styled.div`
	justify-content: space-between;
	// @media (min-width:936px){
	// 	padding: 0.45rem 0.55rem;
	// }
		padding: 0.45rem 0;

	&.showfacet-toggle{
			.switch {
			width: 36px;
			height: 14px;
		}
		.slider::before {
			height: 21px;
			width: 21px;
			top: -5px;
		}
	}	
	span{
		color: var(--textColor);
    font-family: Inter;
    font-size: 14px;
		line-height:16px;
		font-weight: 500;
	}
`;

export const DivnoRoof = styled.div`
		color:   var(--textColor);
		padding: .85rem 1rem;
    margin-top: 1rem;
    background: var(--defaultBgColor);
    border-radius: 2px;
`;
